import React, { Component } from 'react'
import HttpServices from '../../../../utils/Http.services'
import { checkTranslation, imageAddress, translate } from '../../../../utils/useful'

export default class ForwardList extends Component {
    state = {
        contactsList: [],
        selectedList: [],
        search: '',
        selected: 0,
        checkBox: {},
    }



    search = (event) => {

        this.setState({ search: event.target.value }, () => {
            let contactsListFiltered = this.state.contactsList.filter((e) =>
                e.fullname.toLowerCase().includes(this.state.search.toLowerCase())
            )
            this.setState({ contactsListFiltered }, () => {
                console.log("contactlist", contactsListFiltered)
            })
        })
    }

    componentDidMount = () => {
        console.log('here111')
        let body = {}
        this.setState({ isLoadingData: true })

        HttpServices.request('searchHubs', body, (fetchResult, fetchError) => {

            // console.log(fetchResult)
            this.setState({ isLoadingData: false })
            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                return
            }

            this.setState({ contactsList: fetchResult.info, contactsListFiltered: fetchResult.info }, () => {

            })
        })
    }

    selectContact = (prop) => {
        let selectedList = this.state.selectedList
        if (selectedList.includes(prop._id)) {
            let index = selectedList.indexOf(prop._id)
            selectedList.splice(index, 1)
        }
        else {
            selectedList.push(prop._id)
        }
        this.setState({ selectedList })
    }

    changeValue = (key, value, cb) => {
        this.setState({ [key]: value }, () => {
            if (cb) {
                cb()
            }
        })
    }

    openSidebar = () => {
        this.sidebarView.openSidebar()
    }

    openFirstView = () => {
        this.firstView.showView()
    }

    openMemberView = () => {
        this.memberView.showView()
    }

    render() {
        return (
            <div>
                <div className='position-sticky h-100 blur-bg' style={{ top: 0 }}>
                    <div className='flexcb px-3 pt-3' >
                        <button className='flexc' >
                            {/* <img width={20} src='/assets/icons/arrow-left-blue.svg' /> */}
                            <p className='font-size-12' style={{ color: "#0085ff" }}>{translate('messenger.Connection Lists')}</p>
                        </button>
                        <div onClick={() => this.props.forwardMessage(this.state.selectedList)}>
                            <button className='mx-2 px-3 py-1 br-5 blue-btn' >
                                <p style={{ color: "#fff" }}>{translate('messenger.Send')}</p>
                            </button>
                        </div>
                    </div>
                    <div className="mx-3 py-3 mt-2" style={{ borderBottom: "1px solid #eee" }}>
                        <div style={{ backgroundColor: '#f6f6f6', borderRadius: 10 }}>
                            <input onChange={e => this.search(e)} value={this.state.search} className="py-2 px-2 w-100" placeholder={translate('messenger.Search')} style={{ backgroundColor: 'transparent', border: 'none' }} />
                        </div>
                    </div>
                </div>
                <div className='mx-3 py-2 br-10'>
                    <div className='br-10 d-flex flex-column'>
                        {this.state.contactsListFiltered?.map((prop) => {
                            // console.log('propis', prop?.image?.at(0))
                            return (
                                <button className='hover-gray2 br-5 px-2' onClick={() => this.selectContact(prop)}>
                                    {this.state.selectedList.includes(prop._id) ?
                                        (
                                            <div className='flexcb py-2'>
                                                <div className='flexc'>
                                                    <img className='br-50' style={{ objectFit: "cover" }} width={30} height={30} src={imageAddress(prop?.image, 'profile')} />
                                                    <p className='mld-2'>{checkTranslation(prop.fullname)}</p>
                                                </div>
                                                <img width={20} src='/assets/icons/messenger/check-fill.svg' />
                                            </div>
                                        ) : (
                                            <div className='flexcb py-2'>
                                                <div className='flexc'>
                                                    <img className='br-50' style={{ objectFit: "cover" }} width={30} height={30} src={imageAddress(prop?.image, 'profile')} />
                                                    <p className='mld-2'>{checkTranslation(prop.fullname)}</p>
                                                </div>
                                                <img width={20} src='/assets/icons/messenger/check.svg' />
                                            </div>
                                        )}
                                </button>
                            )
                        })}
                    </div>
                </div>
                {/* <div style={{ position: "fixed", bottom: 10, right: 10 }}>
                    <button className='mx-2 blue-btn px-3 py-1 br-5' onClick={() => this.createGroup()}>
                        <p style={{ color: "#fff", fontSize: 14 }}>Save</p>
                    </button>
                </div> */}
            </div>
        )
    }
}
